"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardGroup = CardGroup;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _styledCardGroup = require("./styled-card-group");
var _excluded = ["className", "title", "titleTag", "description", "xxsColumns", "mColumns", "lColumns", "children", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  className: 'fuse-card-group',
  dataTestId: 'fuse-card-group-test-id',
  description: undefined,
  lColumns: 3,
  mColumns: 3,
  title: undefined,
  titleTag: 'h2',
  xxsColumns: 1
};
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  description: _propTypes["default"].string,
  lColumns: _propTypes["default"].oneOf([2, 3, 4]),
  mColumns: _propTypes["default"].oneOf([2, 3, 4]),
  title: _propTypes["default"].string,
  titleTag: _propTypes["default"].string,
  xxsColumns: _propTypes["default"].oneOf([1, 2])
};
function CardGroup(_ref) {
  var className = _ref.className,
    title = _ref.title,
    titleTag = _ref.titleTag,
    description = _ref.description,
    xxsColumns = _ref.xxsColumns,
    mColumns = _ref.mColumns,
    lColumns = _ref.lColumns,
    children = _ref.children,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  var hasText = title || description;
  return /*#__PURE__*/_react["default"].createElement(_styledCardGroup.StyledCardGroup, _extends({
    className: className,
    "data-testid": dataTestId
  }, props), hasText && /*#__PURE__*/_react["default"].createElement(_styledCardGroup.StyledTextWrapper, {
    xxs: "12"
  }, title && /*#__PURE__*/_react["default"].createElement(_styledCardGroup.StyledTitle, {
    size: {
      xxs: '3',
      m: '4',
      l: '5'
    },
    tag: titleTag,
    type: "heading"
  }, title), description && /*#__PURE__*/_react["default"].createElement(_styledCardGroup.StyledDescription, {
    size: "1",
    type: "paragraph"
  }, description)), children.map(function (card, i) {
    return /*#__PURE__*/_react["default"].createElement(_grid.GridItem
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: i,
      className: "fuse-card-group__grid-item-content",
      "data-testid": "fuse-card-group-grid-item-content-".concat(i),
      xxs: xxsColumns ? 12 / xxsColumns : '12',
      m: mColumns ? 12 / mColumns : '4',
      l: lColumns ? 12 / lColumns : '4'
    }, card);
  }));
}
CardGroup.propTypes = propTypes;
CardGroup.defaultProps = defaultProps;
var _default = exports["default"] = CardGroup;